import { Modal, Tag, Card } from 'antd'
import { SafetyOutlined } from "@ant-design/icons"
import { IPermission } from '../../models/role.model'
import { permissionOptions } from '../../assets/constants/default_options'

export const roleColors = ['purple', 'blue', 'green', 'orange', 'red', 'cyan', 'magenta', 'gold']

export default function ModalDetailRole({ detail, setDetail }: any) {
    return (
        <Modal
            width={900}
            title={
                <div style={{
                    textAlign: 'center',
                    padding: '16px 0',
                    background: 'linear-gradient(#e51623 0% 0%, #5f0d0d 100%)',
                    margin: '-16px -24px 20px -24px',
                    color: 'white'
                }}>
                    <SafetyOutlined style={{
                        fontSize: '24px',
                    }} />
                    <div style={{ fontSize: '18px', fontWeight: '600' }}>
                        Chi tiết quyền: {detail?.data?.name}
                    </div>
                </div>
            }
            open={detail.isOpen}
            onCancel={() => setDetail({ data: null, isOpen: false })}
            footer={[]}
            style={{ top: 20 }}
        >
            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {(() => {
                    const groupedPermissions: { [key: string]: { permission: IPermission, detail: any }[] } = {}
                    detail.data?.permissions?.forEach((perm: IPermission) => {
                        const permissionDetail = permissionOptions
                            .find(item => item.value === `${perm.action}::${perm.resource}`)
                        const groupName = permissionDetail?.name || ''
                        if (!groupedPermissions[groupName]) {
                            groupedPermissions[groupName] = []
                        }
                        groupedPermissions[groupName].push({
                            permission: perm,
                            detail: permissionDetail
                        })
                    })
                    return Object.entries(groupedPermissions).map(([groupName, permissions], groupIndex) => (
                        <Card
                            key={groupIndex}
                            style={{
                                marginBottom: '16px',
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                            }}
                        >
                            <div style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: roleColors[groupIndex % roleColors.length],
                                marginBottom: '12px',
                                padding: '4px 8px',
                                background: `linear-gradient(135deg, ${roleColors[groupIndex % roleColors.length]}15 0%, ${roleColors[groupIndex % roleColors.length]}05 100%)`,
                                borderRadius: '8px',
                                border: `1px solid ${roleColors[groupIndex % roleColors.length]}30`
                            }}>
                                <SafetyOutlined style={{ marginRight: '8px' }} />
                                {groupName} ({permissions.length})
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {permissions.map(({ detail }, index) => (
                                    <Tag
                                        key={index}
                                        style={{
                                            margin: 0,
                                            padding: '4px 8px',
                                            borderRadius: '20px',
                                            background: `${roleColors[groupIndex % roleColors.length]}20`,
                                            color: roleColors[groupIndex % roleColors.length],
                                            border: `1px solid ${roleColors[groupIndex % roleColors.length]}40`,
                                            fontWeight: '500'
                                        }}
                                    >
                                        {detail?.label}
                                    </Tag>
                                ))}
                            </div>
                        </Card>
                    ))
                })()}
            </div>
        </Modal>
    )
}
